import Swal from "sweetalert2";
import axios from "axios";
import router from "@/router";
import { parse, format, isValid, parseISO } from "date-fns";

export const fieldToName = n => {
    const result = n.replace(/([A-Z])/g, " $1");
    return result.charAt(0).toUpperCase() + result.slice(1);
}

export const fetchLanguages = async (query) => {
    // From: https://www.back4app.com/database/paul-datasets/list-of-all-programming-languages/get-started/javascript/rest-api/fetch?objectClassSlug=dataset

    console.log('query', query)

    let where = ''

    if (query) {
        where = '&where=' + encodeURIComponent(JSON.stringify({
            "ProgrammingLanguage": {
                "$regex": `${query}|${query.toUpperCase()}|${query[0].toUpperCase() + query.slice(1)}`
            }
        }))
    }

    const response = await fetch(
        'https://parseapi.back4app.com/classes/All_Programming_Languages?limit=9999&order=ProgrammingLanguage&keys=ProgrammingLanguage' + where,
        {
            headers: {
                'X-Parse-Application-Id': 'XpRShKqJcxlqE5EQKs4bmSkozac44osKifZvLXCL', // This is the fake app's application id
                'X-Parse-Master-Key': 'Mr2UIBiCImScFbbCLndBv8qPRUKwBAq27plwXVuv', // This is the fake app's readonly master key
            }
        }
    );

    const data = await response.json(); // Here you have the data that you need

    return data.results.map((item) => {
        return {value: item.ProgrammingLanguage, label: item.ProgrammingLanguage}
    })
}

export function fetchData({ url, filters, onSuccess, onError, mock }) {
    if (mock && [
        'submitEvaluationResult', 'completeEvaluation', 'submitReport',
        'notifyContractManagement', 'cancelProcess', 'postQualification',
        'notifyConflictDeclaration', 'notifyBestBidder', 'requestCorrections',
        'approveEvaluation', 'notifyIntentionToAward', 'requestClarification',
        'notifyUnsuccessfulBidders', 'manageStandstill', 'evaluateAppeals',
        'holdEvaluation', 'notifyZPPACommittee', 'notifyZPPAContract'
    ].some(endpoint => url.includes(endpoint))) {
        setTimeout(() => onSuccess(mock()), 500);
        return;
    }
    let newHeader = {
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('jwt')}`
        }
    };
    axios.post(url, {...filters, realmId: sessionStorage.getItem('realmId')}, newHeader)
        .then(res => {
            if (typeof onSuccess === 'function') {
                onSuccess(res.data)
            }
            else {
                console.log(res)
            }
        })
        .catch(error => {
            if(error.status === 401) {
                Swal.fire({
                    title: 'Session error',
                    icon: "error",
                    text: 'Sorry, an error occurred retrieving your session information. You will be logged out. Log in again and try again',
                    showCancelButton: false,
                    confirmButtonText: "Alright. I understand",
                }).then(() => {
                    router.push({ name: 'logout' });
                })
                return
            }
            if(error.status === 403) {
                console.error("Sorry, We were unable to reach your service. Please confirm that it is running")
            }
            if (typeof onError === 'function') {
                onError(error)
            }
            else {
                console.log(error);
            }
        });
}

export const fetchFormData = ({url, filtersDto, onSuccess = null, onError = null}) => {
    axios.post(url, filtersDto)
        .then(res => {
            if (typeof onSuccess === 'function') {
                onSuccess(res.data)
            }
            else {
                console.log(res)
            }
        })
        .catch(error => {
            if(error.status === 401) {
                Swal.fire({
                    title: 'Session error',
                    icon: "error",
                    text: 'Sorry, an error occurred retrieving your session information. You will be logged out. Log in again and try again',
                    showCancelButton: false,
                    confirmButtonText: "Alright. I understand",
                }).then(() => {
                    router.push({ name: 'logout' });
                })
                return
            }
            if (typeof onError === 'function') {
                onError(error)
            }
            else {
                console.log(error);
            }
        });
}

// eslint-disable-next-line no-unused-vars
function replaceCharacters(str, charsToReplace, replacement) {
    // Create a regular expression from the list of characters
    let regex = new RegExp(`[${charsToReplace}]`, 'g');
    // Replace all occurrences of the characters with the replacement
    return str.replace(regex, replacement);
}

export const postData = ({
                             url,
                             data,
                             noticeMessageTitle = "Submit this form",
                             noticeMessage = null,
                             onSuccess = null,
                             onError = null,
                             onComplete = null,
                             callBackUrl = null,
                             onCancel = null,
                         }) => {
    Swal.fire({
        title: noticeMessageTitle,
        icon: "question",
        text: noticeMessage,
        showCancelButton: true,
        confirmButtonText: "Yes, Go ahead",
        cancelButtonText: "No, cancel!",
        showLoaderOnConfirm: true,
        confirmButtonColor: "#387173",
        cancelButtonColor: "#ff7f41",
        reverseButtons: true,
        preConfirm: async () => {
            try {
                const headers = {
                    Authorization: `Bearer ${sessionStorage.getItem("jwt")}`,
                };
                const response = await axios.post(url, {...data, realmId: sessionStorage.getItem('realmId')}, { headers });

                if (!response || !response.data) {
                    throw new Error("No response data received from the server.");
                }

                if (typeof onSuccess === "function") {
                    onSuccess(response.data);
                } else {
                    console.log(JSON.stringify(response.data, null, 2));
                }

                return response.data; // Ensure response.data is returned
            } catch (error) {
                if(error.status === 401) {
                    Swal.fire({
                        title: 'Session error',
                        icon: "error",
                        text: 'Sorry, an error occurred retrieving your session information. You will be logged out. Log in again and try again',
                        showCancelButton: false,
                        confirmButtonText: "Alright. I understand",
                    }).then(() => {
                        router.push({ name: 'logout' });
                    })
                    return
                }
                console.error("Request failed:", error.response.data);

                // 🛠️ **Fix: Always return a valid object, even on errors**
                const errorData = error.response.data ?? {
                    responseCode: "ERROR",
                    responseMessage: error.response.data.status === 401
                        ? "Unauthorized access. Please log in."
                        :
                        error.response.data.status === 500
                            ? "Application Error!"
                            :
                            error.response.data.status === 403
                                ? "Access Forbidden!"
                                : "An unknown error occurred"
                    ,
                };
                if (typeof onError === "function") {
                    onError(error);
                } else {
                    await Swal.fire({
                        icon: "error",
                        title: "Error!",
                        text: errorData.responseMessage,
                    });
                }

                return errorData;
            }
        },
        allowOutsideClick: false,
    })
        .then((result) => {
            if (result.isConfirmed && result.value) {
                const resData = result.value;

                //if (resData.responseCode && resData.responseCode === "SUCCESS") {
                if (resData.responseCode === "SUCCESS") {
                    if (typeof onComplete === "function") {
                        onComplete();
                    } else if (callBackUrl) {
                        router.push({ name: callBackUrl });
                    } else {
                        Swal.fire({
                            icon: "success",
                            title: "Success!",
                            text: resData.responseMessage,
                        });
                    }
                } else {
                    Swal.fire({
                        icon: "warning",
                        title: "System error!",
                        text: resData.responseMessage || "An unknown error occurred.",
                    });
                }
            } else if (result.dismiss) {
                if (typeof onCancel === "function") {
                    onCancel(result.dismiss);
                }
            } else {
                console.log("No valid data returned from the request.");
            }
        })
        .catch((err) => {
            console.error("Unexpected error:", err);
        });
};

export const parseErrorMessages = inputString => {
    let outHtml = '';
    const resultArray = inputString.split(', ');
    for (let k = 0; k < resultArray.length; k++) {
        outHtml += '<span class="text text-danger">' + resultArray[k] + '</span><br/>'
    }
    return outHtml;
}

export const postMultipartFormDataWithSweetAlertMessages = ({
                                                                url,
                                                                data,
                                                                noticeMessageTitle = null,
                                                                noticeMessage = null,
                                                                onSuccess = null,
                                                                onError = null,
                                                                onComplete = null,
                                                                resData = null,
                                                                callBackUrl = null,
                                                            }) => {
    Swal.fire({
        title: noticeMessageTitle || "Submit this form",
        icon: "question",
        text: noticeMessage || null,
        showCancelButton: true,
        confirmButtonText: "Yes, Go ahead",
        cancelButtonText: "No, cancel!",
        showLoaderOnConfirm: true,
        confirmButtonColor: "#556ee6",
        cancelButtonColor: "#f46a6a",
        reverseButtons: true,
        preConfirm: () => {
            // eslint-disable-next-line no-unused-vars
            return new Promise((resolve, reject) => {
                let newHeader = {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        Authorization: `Bearer ${sessionStorage.getItem('jwt')}`,
                    }
                };
                axios.post(url, data, newHeader)
                    .then((res) => {
                        if (typeof onSuccess === 'function') {
                            onSuccess(res)
                            console.log(JSON.stringify(res, null, 2))
                        }
                        else {
                            // Todo: Remove on production
                            Swal.fire({
                                icon: 'success',
                                title: "Success!",
                                text: res.responseMessage,
                            }).then(() => {
                                if (typeof onComplete === 'function') {
                                    onComplete()
                                }
                            });
                            console.log(JSON.stringify(res.data, null, 2))
                        }
                        resData = res.data;
                        resolve();
                    })
                    .catch((error) => {
                        if(error.status === 401) {
                            Swal.fire({
                                title: 'Session error',
                                icon: "error",
                                text: 'Sorry, an error occurred retrieving your session information. You will be logged out. Log in again and try again',
                                showCancelButton: false,
                                confirmButtonText: "Alright. I understand",
                            }).then(() => {
                                router.push({ name: 'logout' });
                            })
                            return
                        }
                        Swal.fire({
                            icon: 'error',
                            title: "error!",
                            text: error.message,
                        }).then(() => {
                            if (typeof onError === 'function') {
                                onError(error)
                            }
                        })
                        console.log(error.message);
                        /*this.isLoading = false;*/
                        try {
                            // reject(error.message)
                        }
                        catch (e) {
                            console.log(e)
                        }
                    });
            });
        },
        allowOutsideClick: false,
    }).then(r => {
        console.log('resData', resData)
        if (r.isConfirmed) {
            if (resData.responseCode === "SUCCESS") {
                if (typeof onSuccess === 'function') {
                    onSuccess(resData)
                }
                else {
                    Swal.fire({
                        icon: 'success',
                        title: "Success!",
                        html: resData.responseMessage,
                    }).then(() => {
                        if (typeof onComplete === 'function') {
                            onComplete()
                        }
                        else {
                            router.push({name: callBackUrl})
                        }
                    });
                }
            }
            else {
                Swal.fire({
                    icon: 'warning',
                    title: "Validation error!",
                    html: parseErrorMessages(resData.responseMessage),
                }).then(() => {
                    if (typeof onComplete === 'function') {
                        onComplete()
                    }
                });
            }
        }
    });
}

export const getDataAnonymous = ({url, onSuccess = null, onError = null}) => {
    let newHeader = {
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('jwt')}`,
        }
    };
    axios.get(url, newHeader)
        .then(res => {
            if (typeof onSuccess === 'function') {
                onSuccess(res.data)
            }
            else {
                console.log(res)
            }
        })
        .catch(error => {
            if (typeof onError === 'function') {
                onError(error)
            }
            else {
                console.log(error);
            }
        });
}


export const postDataWithSweetAlertMessages = ({
                                                   url,
                                                   data,
                                                   noticeMessageTitle = null,
                                                   noticeMessage = null,
                                                   onSuccess = null,
                                                   onError = null,
                                                   onComplete = null,
                                                   resData = null,
                                                   callBackUrl = null,
                                               }) => {
    Swal.fire({
        title: noticeMessageTitle || "Submit this form",
        icon: "question",
        text: noticeMessage || null,
        showCancelButton: true,
        confirmButtonText: "Yes, Go ahead",
        cancelButtonText: "No, cancel!",
        showLoaderOnConfirm: true,
        confirmButtonColor: "#556ee6",
        cancelButtonColor: "#f46a6a",
        reverseButtons: true,
        preConfirm: () => {
            // eslint-disable-next-line no-unused-vars
            return new Promise((resolve, reject) => {
                let newHeader = {
                    headers: {
                        Authorization: `Bearer ${sessionStorage.getItem('jwt')}`
                    }
                };
                axios.post(url, data, newHeader)
                    .then((res) => {
                        if (typeof onSuccess === 'function') {
                            onSuccess(res)
                            console.log(JSON.stringify(res, null, 2))
                        }
                        else {
                            // Todo: Remove on production
                            Swal.fire({
                                icon: 'error',
                                title: "Error!",
                                text: res.responseMessage,
                            }).then(() => {
                                if (typeof onComplete === 'function') {
                                    onComplete()
                                }
                            });
                            console.log(JSON.stringify(res.data, null, 2))
                        }
                        resData = res.data;
                        resolve();
                    })
                    .catch((error) => {
                        if(error.status === 401) {
                            Swal.fire({
                                title: 'Session error',
                                icon: "error",
                                text: 'Sorry, an error occurred retrieving your session information. You will be logged out. Log in again and try again',
                                showCancelButton: false,
                                confirmButtonText: "Alright. I understand",
                            }).then(() => {
                                router.push({ name: 'logout' });
                            })
                            return
                        }
                        Swal.fire({
                            icon: 'error',
                            title: "error!",
                            text: error.message,
                        }).then(() => {
                            if (typeof onError === 'function') {
                                onError(error)
                            }
                        })
                        console.log(error.message);
                        /*this.isLoading = false;*/
                        try {
                            // reject(error.message)
                        }
                        catch (e) {
                            console.log(e)
                        }
                    });
            });
        },
        allowOutsideClick: false,
    }).then(r => {
        console.log('resData', resData)
        if (r.isConfirmed) {
            if (resData.responseCode === "SUCCESS") {
                if (typeof onSuccess === 'function') {
                    onSuccess(resData)
                }else {
                    Swal.fire({
                        icon: 'success',
                        title: "Success!",
                        html: resData.responseMessage,
                    }).then(() => {
                        if (typeof onComplete === 'function') {
                            onComplete()
                        }else {
                            router.push({name: callBackUrl})
                        }
                    });
                }
            }
            else {
                Swal.fire({
                    icon: 'warning',
                    title: "Validation error!",
                    html: parseErrorMessages(resData.responseMessage),
                }).then(() => {
                    if (typeof onComplete === 'function') {
                        onComplete()
                    }
                });
            }
        }
    });
}


export const postDataWithoutAlerts = ({
                                          url,
                                          data,
                                          onSuccess = null,
                                          onError = null,
                                          onComplete = null,
                                          callBackUrl = null,
                                      }) => {
    const sendRequest = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${sessionStorage.getItem("jwt")}`,
            };
            const response = await axios.post(url, data, { headers });

            if (typeof onSuccess === "function") {
                onSuccess(response.data);
            } else {
                console.log(JSON.stringify(response.data, null, 2));
            }
            return response.data; // Return the response data
        } catch (error) {
            if(error.status === 401) {
                Swal.fire({
                    title: 'Session error',
                    icon: "error",
                    text: 'Sorry, an error occurred retrieving your session information. You will be logged out. Log in again and try again',
                    showCancelButton: false,
                    confirmButtonText: "Alright. I understand",
                }).then(() => {
                    router.push({ name: 'logout' });
                })
                return
            }
            if (typeof onError === "function") {
                onError(error);
            }
            console.error(error.message);
            return null; // Return null to indicate an error
        }
    };

    sendRequest()
        .then((resData) => {
            if (resData && resData.responseCode === "SUCCESS") {
                if (typeof onComplete === "function") {
                    onComplete();
                } else if (callBackUrl) {
                    router.push({ name: callBackUrl });
                } else {
                    console.log("Operation successful", resData.responseMessage);
                }
            } else if (resData) {
                console.warn("Validation error", resData.responseMessage);
            } else {
                console.log("No data returned from the request.");
            }
        })
        .catch((err) => {
            console.error("Unexpected error:", err);
        });
};

export const postDataWithoutAlertsNoHeader = ({
                                                  url,
                                                  data,
                                                  onSuccess = null,
                                                  onError = null,
                                                  onComplete = null,
                                                  callBackUrl = null,
                                              }) => {
    const sendRequest = async () => {
        try {
            const response = await axios.post(url, data);

            if (typeof onSuccess === "function") {
                onSuccess(response.data);
            } else {
                console.log(JSON.stringify(response.data, null, 2));
            }
            return response.data; // Return the response data
        } catch (error) {
            if(error.status === 401) {
                Swal.fire({
                    title: 'Session error',
                    icon: "error",
                    text: 'Sorry, an error occurred retrieving your session information. You will be logged out. Log in again and try again',
                    showCancelButton: false,
                    confirmButtonText: "Alright. I understand",
                }).then(() => {
                    router.push({ name: 'logout' });
                })
                return
            }
            if (typeof onError === "function") {
                onError(error);
            }
            console.error(error.message);
            return null; // Return null to indicate an error
        }
    };

    sendRequest()
        .then((resData) => {
            if (resData && resData.responseCode === "SUCCESS") {
                if (typeof onComplete === "function") {
                    onComplete();
                } else if (callBackUrl) {
                    router.push({ name: callBackUrl });
                } else {
                    console.log("Operation successful", resData.responseMessage);
                }
            } else if (resData) {
                console.warn("Validation error", resData.responseMessage);
            } else {
                console.log("No data returned from the request.");
            }
        })
        .catch((err) => {
            console.error("Unexpected error:", err);
        });
};

export const postUpload = ({
                               url,
                               data,
                               onSuccess = null,
                               onError = null,
                               onComplete = null,
                               callBackUrl = null,
                           }) => {
    const sendRequest = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${sessionStorage.getItem("jwt")}`,
            };
            const response = await axios.post(url, data, { headers });

            if (typeof onSuccess === "function") {
                onSuccess(response);
            } else {
                console.log(JSON.stringify(response, null, 2));
            }
            return response; // Return the response data
        } catch (error) {
            if(error.status === 401) {
                Swal.fire({
                    title: 'Session error',
                    icon: "error",
                    text: 'Sorry, an error occurred retrieving your session information. You will be logged out. Log in again and try again',
                    showCancelButton: false,
                    confirmButtonText: "Alright. I understand",
                }).then(() => {
                    router.push({ name: 'logout' });
                })
                return
            }
            if (typeof onError === "function") {
                onError(error);
            }
            console.error(error.message);
            return null; // Return null to indicate an error
        }
    };

    sendRequest()
        .then((resData) => {
            if (resData && resData.data.responseCode === "SUCCESS") {
                if (typeof onComplete === "function") {
                    onComplete(resData.data);
                } else if (callBackUrl) {
                    router.push({ name: callBackUrl });
                } else {
                    console.log("Operation successful", resData.data.responseMessage.responseMessage);
                }
            } else if (resData) {
                console.warn("Validation error", resData.data.responseMessage.responseMessage);
            } else {
                console.log("No data returned from the request.");
            }
        })
        .catch((err) => {
            console.error("Unexpected error:", err);
        });
};

export const processTableRows = (context, res) => {
    if (res.data.length) {
        context.tableColumns = []
        context.tableData = res.data
        context.totalPages = res.totalPages
        context.page = res.currentPage + 1
        context.filters.pageNumber = res.currentPage
        context.totalRecords = res.totalCount
        for (let i in context.tableData[0]) {
            if (!context.exceptions[i]) {
                context.tableColumns.push(i)
            }
        }
        context.noResults = false
    }
    else {
        context.noResults = true
    }
}


export const populateTableRows = (context, data) => {
    if (data.length) {
        context.tableColumns = []
        context.tableData = data
        context.totalPages = data.totalPages
        context.page = data.currentPage + 1
        context.filters.pageNumber = data.currentPage
        context.totalRecords = data.length
        for (let i in context.tableData[0]) {
            if (!context.exceptions[i]) {
                context.tableColumns.push(i)
            }
        }
        context.noResults = false
    }
    else {
        context.noResults = true
    }
}
export const formatDateTimeShort = isoString => {
    const date = new Date(isoString);

    // Define month names
    const months = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    // Extract day, month, year, hours, and minutes
    const day = date.getUTCDate();
    const month = months[date.getUTCMonth()];
    const year = date.getUTCFullYear();
    const hours = date.getUTCHours().toString().padStart(2, '0');
    const minutes = date.getUTCMinutes().toString().padStart(2, '0');

    // Return formatted date and time as '12 July, 2024 12:25'
    return `${day} ${month}, ${year} ${hours}:${minutes}`;
}
export const formatDateTime = isoString => {
    if (!isoString || isNaN(new Date(isoString).getTime())) {
        return "Not applicable";
    }
    const date = new Date(isoString);

    // Define month names
    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    // Extract day, month, year, hours, and minutes
    const day = date.getUTCDate();
    const month = months[date.getUTCMonth()];
    const year = date.getUTCFullYear();
    const hours = date.getUTCHours().toString().padStart(2, '0');
    const minutes = date.getUTCMinutes().toString().padStart(2, '0');

    // Return formatted date and time as '12 July, 2024 12:25'
    return `${day} ${month}, ${year} ${hours}:${minutes}`;
}
export const formatDate = dateString => {
    const date = new Date(dateString);

    // Define month names
    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    // Extract day, month, and year
    const day = date.getUTCDate();
    const month = months[date.getUTCMonth()];
    const year = date.getUTCFullYear();

    // Return formatted date as '14, July 2024'
    return `${day} ${month}, ${year}`;
}

export const truncateString = (str, maxLength) => {
    // Check if string length exceeds the maxLength
    if (str.length > maxLength) {
        // Truncate the string and add "..." at the end
        return str.slice(0, maxLength) + '...';
    }
    // Return the original string if it's within the limit
    return str;
}
export const formatNumberToString = (value) => {
    if (typeof value === 'string') {
        return value.replace(/,/g, '');
    }
    return value;
}

export const formatNumber = (value) => {
    if (value == null || isNaN(parseFloat(value))) {
        return '';
    }
    return parseFloat(value).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};

export const getPaginationPages = totalPages => {
    let p = [];
    for (let i = 1; i <= totalPages; i++) {
        p.push(i)
    }
    return p;
}


export const formatToISO = (dateValue) => {
    if (!dateValue) return null;

    let parsedDate;

    // 1. If it's already a Date object, use it directly
    if (dateValue instanceof Date) {
        parsedDate = dateValue;
    }
    // 2. If it's a string, try the various patterns
    else if (typeof dateValue === 'string') {
        const formats = ["yyyy-MM-dd HH:mm", "yyyy-MM-dd", "d/M/yyyy HH:mm", "d/M/yyyy", "d/M/yy HH:mm", "d/M/yy"];

        for (const fmt of formats) {
            const attempt = parse(dateValue, fmt, new Date());
            if (isValid(attempt)) {
                parsedDate = attempt;
                break;
            }
        }
    }

    // 3. Final validation and formatting
    if (!parsedDate || !isValid(parsedDate)) {
        console.error("Invalid date or format provided:", dateValue);
        return null;
    }

    return format(parsedDate, "yyyy-MM-dd'T'HH:mm:ss.SSS");
}

export const formatFromISO = (isoString, includeTime = false) => {
    if (!isoString) return null; // Handle null or empty values

    try {
        const parsedDate = parseISO(isoString);
        const dateFormat = includeTime ? "d/M/yyyy HH:mm" : "d/M/yyyy"; // Choose format
        return format(parsedDate, dateFormat);
    } catch (error) {
        console.error("Invalid ISO date format:", isoString);
        return null;
    }
}
export const checkUserHasRequiredPrivilege = requiredPrivileges => {
  if (requiredPrivileges && requiredPrivileges.length) {
    try {
      let currentUserPrivileges = JSON.parse(sessionStorage.getItem('privileges')) || [];
      const userPrivilegeValues = currentUserPrivileges.map(privilege => privilege.value);
      return requiredPrivileges.some(privilege => userPrivilegeValues.includes(privilege));
    } catch (e) {
      console.error('Error parsing privileges from sessionStorage:', e);
      return false;
    }
  }
  return true;
};
